module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"title":"Nivå {level} Fullført!","subtitle":"Bra jobba!","nextLevel":"Klar for neste nivå?","continue":"Jeg er klar for {level}.{sublevel}"},"en":{"title":"Level {level} Completed!","subtitle":"What a great job!","nextLevel":"Are you ready to level up?","continue":"I\u0027m ready for {level}.{sublevel}"}}')
  delete Component.options._Ctor
}
